// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalWrapper--qsdtg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 2147483641;
  overflow: auto;
  top: 0;
  left: 0;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.modalWrapper--qsdtg .modal--REwep {
  overflow-y: auto;
  margin: auto;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.modalWrapper--qsdtg .modal--REwep::-webkit-scrollbar {
  width: 7px;
}
.modalWrapper--qsdtg .modal--REwep::-webkit-scrollbar-track {
  border-radius: 100vh;
  background: none;
}
.modalWrapper--qsdtg .modal--REwep::-webkit-scrollbar-thumb {
  background: #BCCDFF;
  border-radius: 100vh;
}
.modalWrapper--qsdtg .modalContent--rHZpI {
  padding: 1rem;
}
.modalWrapper--qsdtg .modalHeader--Rvcqo {
  margin-bottom: 1.75rem;
  display: flex;
  height: 2rem;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.modalWrapper--qsdtg .modalHeader--Rvcqo svg {
  width: 1.5rem;
  height: 1.5rem;
}
.modalWrapper--qsdtg .modalFooter--EpiB3 {
  position: fixed;
  bottom: 0px;
  margin-top: 1.5rem;
  display: flex;
  width: 100vw;
  align-items: center;
  border-radius: 0.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.13);
  background: white;
  z-index: 2;
}
.modalWrapper--qsdtg .oneButtonFooter--YLZPu {
  justify-content: flex-end;
}
.modalWrapper--qsdtg .multiButtonFooter--pbOEL {
  justify-content: space-between;
}
@media screen and (min-width: 768px) {
  .modalWrapper--qsdtg {
    height: 100%;
    display: flex;
    overflow: auto;
    background: rgba(0, 0, 0, 0.5);
  }
  .modalWrapper--qsdtg .modal--REwep {
    padding: 2rem;
    position: relative;
    width: 764px;
    max-width: 85vw;
    box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.13);
    margin: 2rem auto;
    height: -moz-fit-content;
    height: fit-content;
    overflow: hidden;
  }
  .modalWrapper--qsdtg .modal--REwep.small--V8hW5 {
    width: 596px;
  }
  .modalWrapper--qsdtg .modalContent--rHZpI {
    padding: 0px;
    height: -moz-fit-content;
    height: fit-content;
  }
  .modalWrapper--qsdtg .modalHeader--Rvcqo {
    margin-bottom: 0.75rem;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }
  .modalWrapper--qsdtg .modalFooter--EpiB3 {
    position: relative;
    margin-top: 2rem;
    display: flex;
    height: 2.75rem;
    width: auto;
    border-radius: 0px;
    padding: 0px;
    box-shadow: none;
  }
  .modalWrapper--qsdtg .oneButtonFooter--YLZPu {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/bodal/style.module.less"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EAAA,4DAAA;AAFF;AANA;EAWI,gBAAA;EACA,YAAA;EAAA,sBAAA;EAAA,kBAAA;EAAA,4DAAA;AAFJ;AAII;EACE,UAAA;AAFN;AAKI;EACE,oBAAA;EACA,gBAAA;AAHN;AAMI;EACE,mBAAA;EACA,oBAAA;AAJN;AASI;EAAA;AAAA;AAIA;EAAA,sBAAA;EAAA,aAAA;EAAA,YAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA;AAAA;AAlCJ;EAqCM,aAAA;EACA,cAAA;AAPN;AAYI;EAAA,eAAA;EAAA,WAAA;EAAA,kBAAA;EAAA,aAAA;EAAA,YAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,sBAAA;EACA,gDAAA;EACA,iBAAA;EACA;AAHA;AA3CJ;EAkDI,yBAAA;AAVJ;AAxCA;EAsDI,8BAAA;AAXJ;AAeA;EACE;IACE,YAAA;IACA,aAAA;IACA,cAAA;IACA,8BAAA;EAbF;EAeI;IAAA,aAAA;IACA,kBAAA;IACA,YAAA;IACA,eAAA;IACA,+CAAA;IACA,iBAAA;IACA,wBAAA;IAAA,mBAAA;IACA;EAPA;EANJ;IAiBI,YAAA;EAbJ;EAiBI;IAAA,YAAA;IACA,wBAAA;IAAA;EADA;EAKA;IAAA,sBAAA;IAAA,aAAA;IAAA,WAAA;IAAA,mBAAA;IAAA,8BAAA;IAAA,kBAAA;IAAA;EAAA;EAIA;IAAA,kBAAA;IAAA,gBAAA;IAAA,aAAA;IAAA,eAAA;IAAA,WAAA;IAAA,kBAAA;IAAA,YAAA;IACA;EADA;EA9BJ;IAmCI,uBAAA;EAjBJ;AACF","sourcesContent":["@import '@boclips-ui/styles/src/colors';\n@import '~@boclips-ui/styles/src/breakpoints';\n\n.modalWrapper {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  z-index: 2147483641; // cookie banner is set to 2147483640, setting it lower reintroduces the welcome modal/cookie banner bug\n  overflow: auto;\n  top: 0;\n  left: 0;\n  @apply bg-white;\n\n  .modal {\n    overflow-y: auto;\n    @apply bg-white rounded m-auto;\n\n    &::-webkit-scrollbar {\n      width: 7px;\n    }\n\n    &::-webkit-scrollbar-track {\n      border-radius: 100vh;\n      background: none;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: @blue-500;\n      border-radius: 100vh;\n    }\n  }\n\n  .modalContent {\n    @apply p-4;\n  }\n\n  .modalHeader {\n    @apply flex flex-row justify-between items-center mb-7 h-8;\n\n    svg {\n      width: 1.5rem;\n      height: 1.5rem;\n    }\n  }\n\n  .modalFooter {\n    @apply flex items-center fixed bottom-0 mt-6 px-4 py-2 w-screen rounded;\n    box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.13);\n    background: white;\n    z-index: 2;\n  }\n\n  .oneButtonFooter {\n    justify-content: flex-end;\n  }\n\n  .multiButtonFooter {\n    justify-content: space-between;\n  }\n}\n\n@media screen and (min-width: @screen-md) {\n  .modalWrapper {\n    height: 100%;\n    display: flex;\n    overflow: auto;\n    background: rgba(black, 0.5);\n    .modal {\n      @apply p-8;\n      position: relative;\n      width: 764px;\n      max-width: 85vw;\n      box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.13);\n      margin: 2rem auto;\n      height: fit-content;\n      overflow: hidden;\n    }\n\n    .modal.small {\n      width: 596px;\n    }\n\n    .modalContent {\n      @apply p-0;\n      height: fit-content;\n    }\n\n    .modalHeader {\n      @apply flex flex-row justify-between w-full mb-3 bg-white;\n    }\n\n    .modalFooter {\n      @apply flex relative mt-8 p-0 w-auto h-11 rounded-none;\n      box-shadow: none;\n    }\n\n    .oneButtonFooter {\n      justify-content: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `modalWrapper--qsdtg`,
	"modal": `modal--REwep`,
	"modalContent": `modalContent--rHZpI`,
	"modalHeader": `modalHeader--Rvcqo`,
	"modalFooter": `modalFooter--EpiB3`,
	"oneButtonFooter": `oneButtonFooter--YLZPu`,
	"multiButtonFooter": `multiButtonFooter--pbOEL`,
	"small": `small--V8hW5`
};
export default ___CSS_LOADER_EXPORT___;
